/**
 * Canon constants of the house — shared by ManoirView (Réglages) and the
 * mobile MenuSheet so both cite ONE source (V4.5 review S3: canon facts
 * don't live in component modules).
 */

// The Manoir's postal address — a verified canon fact (canon/manoir.md).
// Addresses are not translated; never alter it here (Law 1).
export const MANOIR_ADDRESS = "Le Manoir d'Autun · 17 avenue de la République, 71400 Autun";

// App version shown on the Réglages line and the menu's « À propos ».
// Fallback mirrors frontend/package.json.
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';

// Short build identifier baked in at build time (git commit SHA on Railway,
// else a build timestamp — see frontend/scripts/write-build-id.js). Lets the
// owner read EXACTLY which build is live, in the menu footer and the
// ?mapsdebug overlay. 'dev' when running an un-built dev server.
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || 'dev';
